import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-3 gap-3" }
const _hoisted_2 = { class: "flex items-center justify-end" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_input = _resolveComponent("new-input")!
  const _component_new_select = _resolveComponent("new-select")!
  const _component_new_button = _resolveComponent("new-button")!

  return (_openBlock(), _createElementBlock("form", {
    class: "bg-white rounded py-4 px-3",
    onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onFiltersSubmit && _ctx.onFiltersSubmit(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_new_input, {
        placeholder: _ctx.identifierPlaceholder,
        disabled: _ctx.loading,
        value: _ctx.state.identifier,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.identifier) = $event))
      }, null, 8, ["placeholder", "disabled", "value"]),
      _createVNode(_component_new_select, {
        "can-deselect": "",
        placeholder: "Тип идентификатора",
        disabled: _ctx.loading,
        searchable: false,
        options: _ctx.BLACKLIST_TYPES,
        value: _ctx.state.typeId,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.typeId) = $event))
      }, null, 8, ["disabled", "options", "value"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_new_button, {
          disabled: _ctx.loading || _ctx.disabled,
          class: "NewButton--search mr-3",
          type: "submit"
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _createTextVNode(" Поиск ")
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_new_button, {
          disabled: _ctx.loading || _ctx.disabled,
          class: "NewButton--reset",
          onClick: _ctx.onFiltersReset
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _createTextVNode(" Сбросить ")
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ])
    ])
  ], 32))
}